import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ApiService } from '../../../../Services/api.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { UppercaseDirective } from "../../../../Common/Components/pipe/UpperCasePipe/uppercase.pipe";

@Component({
  selector: 'app-add-new-sequence',
  standalone: true,
  imports: [CommonModule, NzCollapseModule, NzIconModule, NzButtonModule, NzSelectModule, FormsModule, ReactiveFormsModule, UppercaseDirective],
  templateUrl: './add-new-sequence.component.html',
  styleUrl: './add-new-sequence.component.scss'
})
export class AddNewSequenceComponent {
  constructor(public apiService: ApiService, private fb: FormBuilder) { }
  @Input() selectedTab: string = "";
  @Input() garmentTypes: any = [];
  @Output() linkDrawer = new EventEmitter<boolean>();

  addDimForm: FormGroup = new FormGroup({});
  descDimForm: FormGroup = new FormGroup({});
  activeTab: string = "Dimension 1";
  validForm: boolean = true;
  linkedStatus = [
    {
      id: 1, name: "Dimension 1", clicked: true
    },
    {
      id: 2, name: "Dimension 1", clicked: false
    }
  ];
  dimArrList: any = [
    {
      id: 1, questionNbr: 1, fieldType: "accordion", collapse: true, groupHeader: "Group", required: true,
      fields: [
        { fieldName: 'Dim1', fieldType: "input", placeholder: "Enter Dim1", formControlName: "dim1", maxLength: 3 },
        { fieldName: "Description", fieldType: "textarea", placeholder: "Enter Description", formControlName: "description" },
        { fieldName: "Garment Type", fieldType: "select", placeholder: "Select", formControlName: "garmentType" }]
    }
  ];

  handleCollapse(i: number) {
    let descArray = this.addDimForm.controls["dimArray"]?.value;
    descArray[i].collapse = !descArray[i].collapse;
    this.addDimForm.get('descArray')?.setValue(descArray);
  }

  ngOnChanges() {
    this.initAddForm();
    this.dimArrList[0].fields[0].fieldName = this.selectedTab == 'Dimension 1' ? 'Dim1' : 'Dim2';
    this.dimArrList[0].fields[0].placeholder = this.selectedTab == 'Dimension 1' ? 'Enter Dim1' : 'Enter Dim2';
  }

  initAddForm() {
    this.addDimForm = this.fb.group({
      dimArray: this.fb.array([],{ validators: this.uniquePairValidator() })
    });
    this.addItemtoDimArray();
  }

  get dimArray() {
    return this.addDimForm.controls["dimArray"] as FormArray;
  }


addItemtoDimArray(count: number = 5) {
  for (let i = 0; i < count; i++) {
    this.descDimForm = this.fb.group({
      dim1: ['', [Validators.required, Validators.maxLength(3)]],
      description: ['', Validators.required],
      garmentType: ['', [Validators.required, Validators.maxLength(3)]],
      collapse: [false]
    });
    this.dimArray.push(this.descDimForm);
  }
}

  get dimArrayControls() {
    return (this.addDimForm.controls["dimArray"] as FormArray).controls as FormGroup[];
  }

  clearRowForm(index: number): void {
    const dimArray = this.addDimForm.get('dimArray') as FormArray;
    if (dimArray && dimArray.at(index)) {
      dimArray.at(index).reset();
    }
  }

  uniquePairValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as FormArray;
    const seenPairs = new Set<string>();
    let hasDuplicate = false;

    for (let i = 0; i < formArray.length; i++) {
      const group = formArray.at(i);
      const dim1 = group.get('dim1')?.value?.toString().trim().toUpperCase() || '';
      const garmentType = group.get('garmentType')?.value?.toString().trim().toUpperCase() || '';

      if (dim1 && garmentType) {
        const pairKey = `${dim1}|${garmentType}`;

        if (seenPairs.has(pairKey)) {
          hasDuplicate = true;
          break; 
        }
        seenPairs.add(pairKey);
      }
    }


    return hasDuplicate ? { nonUniquePairs: true } : null;
  };
}


handleDescriptionTab(event: Event, currentIndex: number): void {

  const isLastRow = currentIndex === this.dimArray.length - 1;

  if (isLastRow) {
    event.preventDefault(); 
    this.addItemtoDimArray(1); 


    const nextRowIndex = currentIndex + 1;
    setTimeout(() => {

      const nextInput = document.querySelector(`.field-input-${nextRowIndex}`) as HTMLElement;
      if (nextInput) {
        nextInput.focus();
      }
    }, 50); 

  } else {

    event.preventDefault();
    const nextRowIndex = currentIndex + 1;
    const nextInput = document.querySelector(`.field-input-${nextRowIndex}`) as HTMLElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
}

  saveDimList() {
    if (!this.validateForm()) {
      return
    }
    let dimPostArr: any = [];
    this.dimArray.value.map((node: any) => {
      if (node.dim1 && node.description) {
        if (this.selectedTab === 'Dimension 1') {
          dimPostArr.push({
            "dim": node.dim1,
            "garmentType": node.garmentType,
            "oldGarmentType": null,
            "longDesc": node.description,
            "seqNo": null,
            "dimType": this.selectedTab === 'Dimension 1' ? 1 : 2,
            "updateType": "ADD"
          })
        }
        else {
          dimPostArr.push({
            "dim": node.dim1,
            "garmentType": node.garmentType,
            "oldGarmentType": null,
            "longDesc": node.description,
            "updateType": "ADD"
          })
        }
      }
    });

    this.apiService.postDimData(dimPostArr, this.selectedTab === 'Dimension 1' ? 'dim1' : 'dim2').subscribe(response => {
      this.apiService.createNotification('success', response?.message);
      this.linkDrawer.emit(false);
    }, err => {
      this.apiService.createNotification('error', err?.error.message);
    })
  }

  validateForm(option?: string) {
    if (this.dimArray.at(0)?.value.dim1 && this.dimArray.at(0)?.value.description) {
      this.validForm = true;
    }
    else {
      this.validForm = false;
    }
    return this.validForm;
  }

  resetForm() {
    this.dimArray.value.map((res: any, i: number) => {
      this.dimArray.at(i)?.patchValue({ dim1: '', description: '', garmentType: '' });
    })
  }

  blockNonAlphanumeric(event: KeyboardEvent): void {
  // Allow system keys like Backspace, Delete, Arrow keys, Tab, etc.
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Check if the pressed key is alphanumeric
  const isAlphanumeric = /^[a-zA-Z0-9]$/.test(event.key);
  
  if (!isAlphanumeric) {
    event.preventDefault(); // This stops the character from typing completely
  }
}
}
